import Vue from "vue";
import axios from "axios";
import auth from "@/services/auth";

axios.defaults.baseURL = process.env.VUE_APP_API;
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;

auth.addTokenFromLocalStorage();
